/** Where a routing map waypoint was created — drives cache/ML and UI treatment. */
export enum WaypointCategoryEnum {
  /** Added on a ride card. */
  RideWaypoint = "RideWaypoint",
  /** Added on a course card; copied onto produced rides with the same category. */
  CourseWaypoint = "CourseWaypoint",
  /** Comes from a customized station-route (ML path) and is replaced when that path changes. */
  MLPathWaypoint = "MLPathWaypoint",
  /** Default waypoint from area settings; copied onto dynamic rides that include the area. */
  AreaWaypoint = "AreaWaypoint",
}
